'use client'

import { motion, useInView } from 'framer-motion'
import { useRef, forwardRef } from 'react'
import { cn } from '@/lib/utils'

interface TimelineContentProps {
  children: React.ReactNode
  as?: keyof JSX.IntrinsicElements
  animationNum: number
  timelineRef: React.RefObject<HTMLElement>
  customVariants?: any
  className?: string
  href?: string
  target?: string
  rel?: string
  onClick?: () => void
}

export const TimelineContent = forwardRef<any, TimelineContentProps>(
  ({ 
    children, 
    as: Component = 'div', 
    animationNum, 
    timelineRef, 
    customVariants,
    className,
    ...props 
  }, ref) => {
    const elementRef = useRef(null)
    const isInView = useInView(timelineRef, { once: true, margin: "-100px" })
    
    const defaultVariants = {
      hidden: { opacity: 0, y: 20 },
      visible: (i: number) => ({
        opacity: 1,
        y: 0,
        transition: {
          delay: i * 0.1,
          duration: 0.5,
          ease: "easeOut"
        }
      })
    }

    const variants = customVariants || defaultVariants

    const MotionComponent = motion(Component as any)
    
    return (
      <MotionComponent
        ref={elementRef}
        custom={animationNum}
        initial="hidden"
        animate={isInView ? "visible" : "hidden"}
        variants={variants}
        className={cn(className)}
        {...props}
      >
        {children}
      </MotionComponent>
    )
  }
)

TimelineContent.displayName = 'TimelineContent'